<template>
  <span class="text-xl font-semibold text-gray-900">{{ $gettext("Sanction et embargo") }}</span>
  <div>
    <span class="text-m font-light text-gray-400">{{ $gettext("Dernière mise à jour :") }}</span>
    <span class="ml-2 text-m font-light text-gray-400">
      {{ $formatDateTimeLong(riskScoring.attributes.updatedAt) }}
    </span>
  </div>
  <div v-if="filteredExecutions.length > 0">
    <div class="text-red-500 m-6">
      <p class="text-m">
        <ExclamationCircleIcon class="inline h-8 w-8 text-red-400" />
        {{ $gettext("Cette personne est ciblée par des sanctions") }}
      </p>
    </div>
  </div>
  <div v-else>
    <div class="text-gray-500 m-6">
      <p class="text-m">
        <CheckCircleIcon class="inline h-8 w-8 text-green-400" />
        {{ $gettext("Aucun résultat") }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/vue/24/outline";

const props = defineProps({
  riskScoring: {
    type: Object,
    required: true
  }
});

const filteredExecutions = computed(() =>
  props.riskScoring.relationships.riskScoringRuleExecutions.data.filter(exec => ["medium", "high"].includes(exec.attributes.level)).filter(exec =>
    ["sanction"].includes(exec.relationships.riskScoringRule.data.attributes.criticality) && exec.attributes.skipped !== true
  )
);
</script>
